export * from "./static-footer/static-footer.component";
export * from "./static-header/static-header.component";